/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const useUnpaidInvoicesCount = (queryParams) =>
  useQuery({
    queryKey: queryKeys.invoices.unpaidCount,
    queryFn: () => fetcher({ method: "GET", url: "/public/invoice", params: { "filter[status]": "unpaid" } }),
    select: (data) => data?.metadata?.items_count || 0,
    ...queryParams,
  });
